import { CSSProperties } from "react";
import styled from "styled-components";

export const CheckinSummaryLayout = styled.div`
  padding: 16px;
  background-color: ${(props) => props.theme["@default-background"]};
  border-radius: 6px;
  box-shadow: 0 1px 5px ${(props) => props.theme["@box-shadow"]};
  margin-bottom: 30px;
  width: 390px;
  height: 180px;
  .divider {
    background-color: ${(props) => props.theme["@muted-background"]};
    height: 146px;
  }
`;

export const LocationSummaryLayout = styled.div`
  padding: 16px;
  background-color: ${(props) => props.theme["@default-background"]};
  border-radius: 6px;
  box-shadow: 0 1px 5px ${(props) => props.theme["@box-shadow"]};
  margin-bottom: 30px;
  width: 210px;
  height: 180px;
`;

export const InboundSummaryLayout = styled.div`
  padding: 16px;
  background-color: ${(props) => props.theme["@default-background"]};
  border-radius: 6px;
  box-shadow: 0 1px 5px ${(props) => props.theme["@box-shadow"]};
  margin-bottom: 30px;
  width: 610px;
  height: 180px;
  .divider {
    background-color: ${(props) => props.theme["@muted-background"]};
    height: 146px;
  }
`;

export const SummaryContainer = styled.div`
  position: relative;
`;

export const SummaryCards = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 72%;
  column-gap: 32px;

  @media (max-width: 768px) {
    grid-template-columns: auto 1fr;
    row-gap: 16px;
  }

  @media (min-width: 769px) and (max-width: ${(props) => (props.$isSidebarCollapsed ? "1450px" : "1627px")}) {
    grid-template-columns: auto 1fr;
    grid-auto-rows: auto;
    row-gap: 16px;

    & > :nth-child(3) {
      grid-column: 1 / -1;
    }
  }
`;

export const SummaryActions = styled.div`
  position: absolute;
  right: 0;
  bottom: 30px;

  @media (max-width: ${(props) => (props.$isSidebarCollapsed ? "2015px" : "2180px")}) {
    position: static;
    width: 100%;
    margin-bottom: 14px;
  }
`;

export const CheckinSummaryContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.6px 1fr;
  column-gap: 25px;
`;

export const CheckinSummaryTitle = styled.h3`
  font-size: ${(props) => props.theme["@medium-font-size"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  margin-bottom: 7px;
`;

export const SummaryDescription = styled.h3`
  font-size: ${(props) => props.theme["@small-font-size"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
`;

export const CheckinSummaryTime = styled.h3`
  font-size: ${(props) => props.theme["@small-font-size"]};
  font-weight: ${(props) => props.theme["@medium-font-weight"]};
  display: flex;
  align-items: center;
`;

export const NumberDescription = styled.h1`
  font-size: 30px;
`;

export const CheckinInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const InboundSummaryContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.6px 1fr 1.6px 1fr;
  column-gap: 20px;
  .warningIcon {
    display: inline-flex;
    height: 32px;
    border-radius: 300px;
    font-weight: ${(props) => props.theme["@medium-font-weight"]};
    font-size: ${(props) => props.theme["@small-font-size"]};
    align-content: center;
    align-items: center;
    padding: 0 12px;
  }
`;

export const InboundSummaryDescription = styled.h3`
  font-size: ${(props) => props.theme["@medium-font-size"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  margin-bottom: 6px;
`;

export const InboundSummarySubtitle = styled.h3`
  font-size: ${(props) => props.theme["@small-font-size"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  margin-bottom: 8px;
`;

export const InboundSummaryTime = styled.h3`
  font-size: ${(props) => props.theme["@small-font-size"]};
  font-weight: ${(props) => props.theme["@medium-font-weight"]};
  display: flex;
  align-items: center;
`;

export const Title = styled.h1`
  font-size: ${(props) => props.theme["@medium-font-size"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  margin-bottom: 5px;
`;

export const Description = styled.h2`
  font-size: ${(props) => props.theme["@small-font-size"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  margin-bottom: 15px;
`;

export const SummaryExtra = styled.div`
  display: grid;
  grid-template-columns: 1fr 13%;
  .dataInformation {
    cursor: help;
    margin-top: -1px;
  }
`;

export const CardInformation = styled.div`
  margin: 10px 15px;
  width: 300px;
`;

export const LoadingContainer: CSSProperties = {
  width: "100%",
  minHeight: "100%",
  height: "-webkit-fill-available",
  alignItems: "center",
  justifyContent: "center",
  display: "grid",
};
